// test2784
(2784 && 0);
